 export class Zone {
    [x: string]: any;
  
   zoneName: string;
      maxChildNumber: string;
      maxChildNumberMin: string;
      maxChildNumberMax: string;
      maxAdultNumberMin: string;
      maxAdultNumber: string;
      maxAdultNumberMax: string;
      roomId: number;
      roomName: string;
   constructor() {
    
 this.zoneName='';
    this.maxChildNumber='';
      this.maxChildNumberMin='';
      this.maxChildNumberMax='';
      this.maxAdultNumberMin=''
      this.maxAdultNumber=''
      this.maxAdultNumberMax=''
      this.roomId =null
      this.roomName=''
 
   }
 }
  